import { useEffect, useState } from "react";
import { Phone, Menu, X, Languages } from "lucide-react";
import { useLang } from "@/i18n";


export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { lang, toggle, str } = useLang();

  const LINKS = [
    { label: str.navHome, href: "#home", id: "home" },
    { label: str.navRates, href: "#rates", id: "live-rates" },
    { label: str.navCharts, href: "#charts", id: "charts" },
    { label: str.navProducts, href: "#products", id: "products" },
    { label: str.navLocation, href: "#location", id: "location" },
    { label: str.navContact, href: "#contact", id: "contact" },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled || open
          ? "bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-6 sm:px-10 lg:px-16 h-16 lg:h-20">
        <a href="#home" data-testid="nav-logo" className="flex items-center shrink-0">
          <img src="/logo.png" alt="Mahima Metals" className="h-9 lg:h-11 w-auto object-contain" />
        </a>

        <div className="hidden xl:flex items-center gap-6 2xl:gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.id}`}
              className="font-ticker text-[11px] tracking-[0.25em] uppercase whitespace-nowrap text-white/55 hover:text-[#25D366] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={toggle}
            data-testid="lang-toggle-btn"
            className="inline-flex items-center gap-1.5 border border-white/20 px-3 py-2 font-ticker text-[11px] tracking-[0.15em] text-white/70 uppercase whitespace-nowrap hover:border-[#25D366] hover:text-[#25D366] transition-colors duration-300"
            aria-label="Switch language"
          >
            <Languages size={12} /> {lang === "en" ? "हिंदी" : "EN"}
          </button>
          <a
            href="tel:+918000093073"
            data-testid="nav-call-btn"
            className="flex items-center gap-2 border border-[#25D366]/60 px-5 py-2.5 font-ticker text-[11px] tracking-[0.2em] text-[#25D366] uppercase whitespace-nowrap hover:bg-[#25D366] hover:text-[#0A0A0A] transition-colors duration-300"
          >
            <Phone size={13} /> +91 80000 93073
          </a>
        </div>

        <div className="xl:hidden flex items-center gap-4">
          <button
            onClick={toggle}
            data-testid="lang-toggle-btn-mobile"
            className="font-ticker text-[11px] tracking-[0.15em] text-[#25D366] uppercase"
          >
            {lang === "en" ? "हिंदी" : "EN"}
          </button>
          <button
            data-testid="nav-menu-toggle"
            className="text-white/80"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="xl:hidden border-t border-white/10 bg-[#0A0A0A]/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-ticker text-xs tracking-[0.25em] uppercase text-white/70 hover:text-[#25D366]"
            >
              {l.label}
            </a>
          ))}
          <a href="tel:+918000093073" className="flex items-center gap-2 font-ticker text-xs tracking-[0.2em] text-[#25D366] uppercase">
            <Phone size={13} /> +91 80000 93073
          </a>
        </div>
      )}
    </header>
  );
}
